import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

const Blocked: FC = () => {
    const trl = useTrls();

    return <div>{trl('campaign.actions.status.stopped.campaign')}</div>;
};

export default Blocked;
